// Import-batch detail page (CHG-1260 / ITER-3377).
//
// Thin per the v8 brief: ≤20 LOC. All configuration in @generated/screens.
// Future generator regenerates importBatchDetailConfig from
// import-batch.entity-hint.yaml (CHG-1235) without touching this file.
//
// Spec: specs/tier-05-experience/import-batch-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { importBatchDetailConfig } from "../generated/screens/import-batch-detail";

export function ImportDetail() {
  return <DetailPage config={importBatchDetailConfig} />;
}
